import React, { useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Dialog, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import useToast from 'src/utils/toast-utils';

const DialogConfirm = ({
  isOpen = false,
  handleClose,
  formik,
  tmsId = 0,
  onCheckIn = async () => {},
  onCheckOut = async () => {},
  onCompleted,
}) => {
  const { toastSuccess, toastError } = useToast(); 
  const isFetchingData = useRef(false);
  
  // Checkout
  const handleConfirmCheckout = async (values) => {
    if (isFetchingData.current) return; // Block duplicate actions
    isFetchingData.current = true; // Set the flag to indicate ongoing action

    handleClose(); // Close dialog immediately
    try {
      values.tmsId = tmsId;
      await onCheckOut(
        values,
        (result) => {
          toastSuccess(`Đã trả xe`);
          // setTimeout(() => {
          //   // Reload page (F5) after success
          // }, 350);
          onCompleted('Out');
        },
        (error) => {
          toastError(error, {duration: 5000});
        },
      );
    } catch (error) {
      toastError(error);
    } finally {
      isFetchingData.current = false; // Reset the flag after completion
    }
  };

  // Checkin
  const handleConfirmCheckin = async (values) => {
    if (isFetchingData.current) return;
    isFetchingData.current = true;

    handleClose();
    try {
      await onCheckIn(
        values,
        (result) => {
          toastSuccess(`Đã nhận xe`);
          // setTimeout(() => {
          //   // Reload page (F5) after success
          // }, 350);
          onCompleted('In');
        },
        (error) => {
          toastError(error, {duration: 6000});
        },
      );
    } catch (error) {
      toastError(error);
    } finally {
      isFetchingData.current = false;
    }
  };

  return (
    <Dialog closeAfterTransition={false}
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {tmsId > 0 ? 'Trả xe' : 'Nhận xe'}
      </DialogTitle>
      <DialogContent>
        {tmsId > 0 ? (
          <Box>
            <Typography>Vui lòng kiểm tra lại xe trước khi trả.</Typography>
            <Typography>
              Bạn trả xe?{' '}
              <strong>{formik.values.plateField?.label || ''}</strong>
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography>
              Vui lòng kiểm tra xe tình trạng của xe trước khi nhận.
            </Typography>
            <Typography>
              Bạn sẽ nhận xe?{' '}
              <strong>{formik.values.plateField?.label || ''}</strong>
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Hủy
        </Button>
        <Button
          onClick={() => {
            if (tmsId > 0) {
              handleConfirmCheckout(formik.values);
            } else {
              handleConfirmCheckin(formik.values);
            }
          }}
          color="primary"
        >
          Xác nhận
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
